import { isServer } from './isServer'

const composeInstallScript = ({ makeScriptUri, name, scriptId }) => options => {
  const scriptSrc = makeScriptUri(options)
  if (!scriptSrc) {
    throw new Error(`${name} not provide valid script uri`)
  }

  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.src = scriptSrc

  if (scriptId) {
    script.id = scriptId
  }

  const s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(script, s)

  return new Promise(resolve => {
    script.addEventListener('load', resolve)
  })
}

const composeInstallation = installOptions => {
  const {
    name,
    install,
    makeScriptUri,
  } = installOptions

  let installed = false

  let doInstall

  if (typeof install === 'function') {
    doInstall = install
  } else if (typeof makeScriptUri === 'function') {
    doInstall = composeInstallScript(installOptions)
  } else {
    throw new Error(`${name} not provide valid installer`)
  }

  return options => {
    if (isServer()) {
      throw new Error(`${name} installation should only run at client side`)
    }

    if (installed) {
      throw new Error(`${name} installation run more than once`)
    }

    try {
      return Promise.resolve(doInstall(options)).then(data => {
        installed = true
        return data
      })
    } catch (ex) {
      return Promise.reject(ex)
    }
  }
}

export default composeInstallation